import { Component, Input, OnDestroy, OnInit, SecurityContext, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CargoPaymentInfo } from 'src/app/models/cargo-payment-info.model';
import { MessageBox } from 'src/app/models/message-box.model';
import { SharedService } from 'src/app/services/shared-service/shared.service';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MessageBoxComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @Input() cargoPaymentInfo?: CargoPaymentInfo;
  currentContinueClick = false;
  currentPaymentType = '';
  message: MessageBox | undefined = undefined;
  sanitizedText = '';

  constructor(private sharedService: SharedService, private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.sharedService.currentPaymentType
      .pipe(takeUntil(this.destroy$))
      .subscribe((paymentType) => (this.currentPaymentType = paymentType));

    this.sharedService.currentContinueClick
      .pipe(takeUntil(this.destroy$))
      .subscribe((isContinueClick) => (this.currentContinueClick = isContinueClick));

    this.sharedService.currentMessage.pipe(takeUntil(this.destroy$)).subscribe((currentMessage) => {
      this.message = currentMessage;
      const raw = currentMessage?.text ?? '';
      this.sanitizedText = this.sanitizer.sanitize(SecurityContext.HTML, raw) ?? '';
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close() {
    this.sharedService.hideMessage();
  }
}
